import React, { useEffect } from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import { useDispatch, useSelector } from "react-redux";
import { convertDate, convertTimeFormat } from "../Services";
import { HiCalendar } from "react-icons/hi";
import moment from "moment";
import { formatTime } from "../utils";
import { IoIosWarning } from "react-icons/io";
import { getDailyUserLectures } from "../Redux/LectureReducer/action";
import { Loader } from "../components/Loader";

const Dashboard = () => {
  const user = useSelector((state) => state.AuthReducer.user);
  const loading = useSelector((state) => state.LectureReducer.isLoading);
  const dailyLectures = useSelector(
    (state) => state.LectureReducer.dailyLectures
  );
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const path = useLocation();
  console.log("user", user)
  const batchId = Object.keys(user).length !== 0 && user.batchId;
  const sectionId = Object.keys(user).length !== 0 && user.sectionId;
  const role = Object.keys(user).length !== 0 && user.roles[0].name;

  useEffect(() => {
    if (dailyLectures?.length === 0) {
      dispatch(getDailyUserLectures(batchId, sectionId));
    }
  }, [dispatch, dailyLectures.length]);

  const validateTime = (startedTime, lectureId) => {
    const mls = moment(formatTime(startedTime));
    const scheduledTime = mls.valueOf();
    const dt = new Date();
    const currentTime = Date.parse(dt);
    const errorMsg =
      currentTime >= scheduledTime - 600000
        ? ""
        : `Lecture available at ${convertDate(
          startedTime
        )} - ${convertTimeFormat(startedTime)}`;
    console.log(errorMsg);
    setErrorMessage((prev) => (prev = errorMsg));
    errorMsg ? navigate("/dashboard") : navigate(`/lectures/${lectureId}`);
  };

  return <>
    <div className="w-[full] h-[100vh] bg-[#f3f4f6] ">
      <Navbar name={user.name} role={role} />
      <Header title="Today's Schedule" role={role} />
      <main>
        <div className="py-12 w-full h-full  ">
          {role === "ROLE_ADMIN" ? "" : <div className="max-w-7xl mx-auto sm:px-6 lg:px-6">
            {/* error section  start*/}
            {errorMessage ? (
              <div className="bg-red-50 overflow-hidden shadow-xl    rounded-md max-w-7xl mx-auto  sm:rounded-lg  ">
                <div className="py-4 text-left pl-2 flex justify-left  ">
                  <IoIosWarning
                    size={"15px"}
                    color="#f87171"
                    className="mt-[1px] ml-1"
                  />{" "}
                  <span className="ml-[10px] text-xs text-red-700">
                    {errorMessage}
                  </span>
                </div>
              </div>
            ) : (
              ""
            )}
            {/* lecture section start */}
            <div className=" overflow-hidden  sm:rounded-lg  px-2  py-2 ">
              <div className="rounded-md max-w-7xl bg-white shadow-xl mx-auto py-4 px-4 ">
              {loading ? <Loader /> : ""}
                {dailyLectures.length > 0 &&
                  dailyLectures.map((lecture) => {
                    return (
                      <div
                        key={lecture.lectureId}
                        className="py-2 px-3  bg-white  w-[95%] mx-auto  "
                        onClick={() => {
                          validateTime(lecture.startTime, lecture.lectureId);
                        }}
                      >
                        <div className="my-2 mx-1 w-[100%]  h-20 flex  ">
                          <div className="w-36 h-full text-center inline-flex flex-wrap bg-[#574ee5] sm:text-sm  sm:flex sm:w-36 px-2 pb-2 ">
                            <span className="mt-[17px] ">
                              <HiCalendar size={"15px"} color="white" />
                            </span>{" "}
                            <p className=" text-[white] text-[500] mt-[10px] sm:inline-flex ml-[5px] text-xl  md:text-xl lg:text-xl font-semibold ">
                              {" "}
                              {convertTimeFormat(lecture.startTime)}{" "}
                            </p>{" "}
                            <p className="text-sm text-center mx-auto text-white sm:inline-flex sm:text-sm font-semibold ">
                              LECTURE
                            </p>
                          </div>
                          <div className="w-[88%] h-full px-2 ml-1">
                            <div className=" h-[33%] text-left">
                              <p className="text-[20px] text-[#574ee5] text-[700] font-semibold ">
                                {lecture.title}
                              </p>
                            </div>
                            <div className="h-[33%] text-left flex justify-between">
                              <div>
                                <p className="text-sm py-1">
                                  <b>
                                    <span className="text-gray-800 font-medium text-sm">
                                      {lecture.createdBy}
                                    </span>
                                  </b>{" "}
                                  <span className="text-gray-600 font-medium text-sm">
                                    starting at
                                  </span>{" "}
                                  <b>
                                    <span className="text-gray-800 font-medium text-sm">
                                      {convertTimeFormat(lecture.startTime)}
                                    </span>
                                  </b>
                                </p>
                              </div>
                              <div className="h-full text-center">
                                <p className="text-sm py-1 text-center pb-[5px] mr-[10px] text-gray-500 font-medium">
                                  Details &gt;
                                </p>
                              </div>
                            </div>
                            <div className=" h-[33%] text-left">
                              <span className="bg-[#bae6fd] rounded-md px-2 py-1 text-center text-xs">
                                {lecture.category}
                              </span>{" "}
                              <span className="ml-1 py-1 text-xs text-center bg-[#d9fae5] rounded-md px-2">
                                {lecture.type}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>

            </div>
          </div>}
        </div>
      </main>
    </div>
  </>
};


export { Dashboard, formatTime };
